import { useLanguage } from '../../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import data from '../../data/data.json';

// Artwork for the two cards comes out of the data file rather than being
// written in here, because the asset names carry a content hash that changes
// whenever the artwork does.
const COLOURING_THUMB = data.colorBook.pages[0]?.pageIllustration;
const STORY_THUMB = data.stories.find((s) => s.lang?.en?.cover)?.lang.en.cover;

const ORDER_FORM = 'https://form.jotform.com/251176476836063';

function HomePage() {
    const { translate } = useLanguage();
    useDocumentTitle(null);

    return (
        <div className="home">
            <h1 className="home-title">{translate('home')}</h1>

            {/* The two things a child came for, before the text a parent
                reads. They used to sit under 146 words of it. */}
            <div className="home-cards">
                <Link to="/colorbook" className="home-card">
                    <span className="home-card-art">
                        <img src={COLOURING_THUMB} alt="" loading="eager" />
                    </span>
                    <span className="home-card-body">
                        <span className="home-card-title">
                            <img src="/assets/img/menu/paint.png" alt="" className="home-card-icon" />
                            {translate('colorBook')}
                        </span>
                        <span className="home-card-blurb">{translate('home_colorbook_blurb')}</span>
                    </span>
                </Link>

                <Link to="/storybook" className="home-card">
                    <span className="home-card-art">
                        <img src={STORY_THUMB} alt="" loading="eager" />
                    </span>
                    <span className="home-card-body">
                        <span className="home-card-title">
                            <img src="/assets/img/menu/book.png" alt="" className="home-card-icon" />
                            {translate('storyBook')}
                        </span>
                        <span className="home-card-blurb">{translate('home_storybook_blurb')}</span>
                    </span>
                </Link>
            </div>

            <section className="home-welcome" aria-labelledby="about-heading">
                <h2 id="about-heading" className="home-welcome-heading">
                    {translate('home_about')}
                </h2>
                {translate('welcomeMessage')
                    .split('\n')
                    .map((line) => line.trim())
                    .filter(Boolean)
                    .map((line, index) => (
                        <p key={index} className="homepage-text">{line}</p>
                    ))}
            </section>

            <div className="home-order">
                <a
                    href={ORDER_FORM}
                    className="homepage-action-button"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src="/assets/img/icons/shipped.png" alt="" className="button-icon" />
                    <span className="button-text">{translate('order_button')}</span>
                </a>
            </div>
        </div>
    );
}

export default HomePage;
